const countingNumbersArray = (length: number): number[] =>
  Array.from({ length }, (_, i) => i + 1);

export const countingNumbersAsDropdownList = (
  length: number,
  quantitySelected?: number
): {
  value: string;
  label: string;
  disabled?: boolean;
}[] =>
  countingNumbersArray(
    typeof quantitySelected === 'number' && quantitySelected > length
      ? quantitySelected
      : length
  ).map(item => ({
    value: item.toString(),
    label: item.toString(),
    disabled:
      typeof quantitySelected === 'number' &&
      quantitySelected > item &&
      length < item,
  }));
